module.exports = __webpack_public_path__ + "static/media/dash.17f637b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/tomate/climasense/xanthomonas_tomate/curativa/dash.png
// module id = 2403
// module chunks = 3